import script from "./list-layout-two.vue?vue&type=script&setup=true&lang=js"
export * from "./list-layout-two.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__